import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Dashboard as DashboardIcon,
  Person as PersonIcon,
  DirectionsCar as VehicleIcon,
  Group as UserIcon,
  LocalTaxi as ActiveDriverIcon,
  AttachMoney as FareIcon,
  Phone as TestNumberIcon,
  Timeline as RidesIcon,
  Support as SupportIcon,
  VerifiedUser as VerificationIcon,
} from '@mui/icons-material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import './SideBar.css';

const Sidebar: React.FC = () => {
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
    { path: '/driver', label: 'Verified Driver', icon: <PersonIcon /> },
    { path: '/vehicle', label: 'Vehicle', icon: <VehicleIcon /> },
    { path: '/user', label: 'User', icon: <UserIcon /> },
    { path: '/active-driver', label: 'Active Driver', icon: <ActiveDriverIcon /> },
    { path: '/fare-management', label: 'Fare Management', icon: <FareIcon /> },
    { path: '/test-numbers', label: 'Test Number', icon: <TestNumberIcon /> },
    { path: '/rides', label: 'Rides', icon: <RidesIcon /> },
    { path: '/support-requests', label: 'Support Request', icon: <SupportIcon /> },
    { path: '/driver-verification', label: 'Driver Verification', icon: <VerificationIcon /> },
    { path: '/notifications', label: 'Notifications', icon: <NotificationsIcon /> },
    { path: '/driver-config', label: 'Driver Config', icon: <PersonIcon /> },
  ];

  return (
    <div className="sidebar-container">
      <div className="sidebar-header">
        <h2>Admin Panel</h2>
      </div>
      <nav className="sidebar-nav">
        <ul className="sidebar-list">
          {menuItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`sidebar-link ${location.pathname === item.path ? 'active-link' : ''}`}
                style={{ color: '#000' }}
              >
                <span className="sidebar-icon">{item.icon}</span>
                <span className="sidebar-label">{item.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
